import React, {useContext} from 'react';
import {keys} from 'lodash/object';
import useMeasure from 'react-use-measure';
import {SIZES, VIEWPORT_WIDTHS} from 'configs';

const ViewportContext = React.createContext({});
const ViewportConsumer = ViewportContext.Consumer;

const getSize = (width) => {
  let size;

  for (let i of keys(SIZES)) {
    if (width >= VIEWPORT_WIDTHS[i]) {
      size = i;
    }
  }

  return size;
};

const ViewportProvider = ({children}) => {
  const [ref, {width}] = useMeasure();

  return (
    <ViewportContext.Provider
      value={{
        size: getSize(width),
      }}
    >
      <div ref={ref}>{children}</div>
    </ViewportContext.Provider>
  );
};

const withViewport = (Component) => {
  return class extends React.Component {
    render() {
      return (
        <ViewportConsumer>
          {(viewport) => <Component viewport={viewport} {...this.props} />}
        </ViewportConsumer>
      );
    }
  };
};

// Hook
const useViewport = () => useContext(ViewportContext);

export {ViewportProvider, ViewportConsumer, withViewport, useViewport};
